import { getAttributeCourseStaticInfo } from './enrolment'

export const isElgibleForFundingType = (potentialFundingType, fundingInfo, personalDetails) => {
  let allowFundingType = fundingInfo.potentialFundingType.filter(funding => funding.fundingType === potentialFundingType).length > 0

  let liabilityCategoryCode = getAttributeCourseStaticInfo('liabilityCategoryCode')

  if (allowFundingType && potentialFundingType === 'SA-HELP') {
    allowFundingType = (personalDetails.stuCitizenCd === '1' || personalDetails.stuCitizenCd === '8') && liabilityCategoryCode === 'CS'
  }

  if (allowFundingType && potentialFundingType === 'FEE-HELP') {
    allowFundingType = (personalDetails.stuCitizenCd === '1' || personalDetails.stuCitizenCd === '8') && liabilityCategoryCode === 'DP'
  }

  if (allowFundingType && potentialFundingType === 'FEE-FREE') {
    allowFundingType = (personalDetails.stuCitizenCd === '1' || personalDetails.stuCitizenCd === '2' || personalDetails.stuCitizenCd === '3' || personalDetails.stuCitizenCd === '8' || personalDetails.stuCitizenCd === 'P')
  }

  return allowFundingType
}

export const isHelpSubmitted = (potentialFundingType, fundingInfo) => {
  return fundingInfo.potentialFundingType.filter(funding => funding.fundingType === potentialFundingType && ['$SUB', '$GOV', '$APR', '$REV'].includes(funding.status)).length > 0
}
